export class PersonenUndStellenbezogeneMerkmale {
  alterFrauen: number;
  alterMaenner: number;
  ausbildungsjahreFrauen: number;
  ausbildungsjahreMaenner: number;
  erwerbsjahreFrauen: number;
  erwerbsjahreMaenner: number;
  dienstjahreFrauen: number;
  dienstjahreMaenner: number;
  betrieblichesKompetenzniveau1FrauenAnzahl: number;
  betrieblichesKompetenzniveau1FrauenAnteil: string;
  betrieblichesKompetenzniveau1MaennerAnzahl: number;
  betrieblichesKompetenzniveau1MaennerAnteil: string;
  betrieblichesKompetenzniveau2FrauenAnzahl: number;
  betrieblichesKompetenzniveau2FrauenAnteil: string;
  betrieblichesKompetenzniveau2MaennerAnzahl: number;
  betrieblichesKompetenzniveau2MaennerAnteil: string;
  betrieblichesKompetenzniveau3FrauenAnzahl: number;
  betrieblichesKompetenzniveau3FrauenAnteil: string;
  betrieblichesKompetenzniveau3MaennerAnzahl: number;
  betrieblichesKompetenzniveau3MaennerAnteil: string;
  betrieblichesKompetenzniveau4FrauenAnzahl: number;
  betrieblichesKompetenzniveau4FrauenAnteil: string;
  betrieblichesKompetenzniveau4MaennerAnzahl: number;
  betrieblichesKompetenzniveau4MaennerAnteil: string;
  betrieblichesKompetenzniveau5FrauenAnzahl: number;
  betrieblichesKompetenzniveau5FrauenAnteil: string;
  betrieblichesKompetenzniveau5MaennerAnzahl: number;
  betrieblichesKompetenzniveau5MaennerAnteil: string;
  betrieblichesKompetenzniveau6FrauenAnzahl: number;
  betrieblichesKompetenzniveau6FrauenAnteil: string;
  betrieblichesKompetenzniveau6MaennerAnzahl: number;
  betrieblichesKompetenzniveau6MaennerAnteil: string;
  betrieblichesKompetenzniveau7FrauenAnzahl: number;
  betrieblichesKompetenzniveau7FrauenAnteil: string;
  betrieblichesKompetenzniveau7MaennerAnzahl: number;
  betrieblichesKompetenzniveau7MaennerAnteil: string;
  betrieblichesKompetenzniveau8FrauenAnzahl: number;
  betrieblichesKompetenzniveau8FrauenAnteil: string;
  betrieblichesKompetenzniveau8MaennerAnzahl: number;
  betrieblichesKompetenzniveau8MaennerAnteil: string;
  beruflicheStellung1FrauenAnzahl: number;
  beruflicheStellung1FrauenAnteil: string;
  beruflicheStellung1MaennerAnzahl: number;
  beruflicheStellung1MaennerAnteil: string;
  beruflicheStellung2FrauenAnzahl: number;
  beruflicheStellung2FrauenAnteil: string;
  beruflicheStellung2MaennerAnzahl: number;
  beruflicheStellung2MaennerAnteil: string;
  beruflicheStellung3FrauenAnzahl: number;
  beruflicheStellung3FrauenAnteil: string;
  beruflicheStellung3MaennerAnzahl: number;
  beruflicheStellung3MaennerAnteil: string;
  beruflicheStellung4FrauenAnzahl: number;
  beruflicheStellung4FrauenAnteil: string;
  beruflicheStellung4MaennerAnzahl: number;
  beruflicheStellung4MaennerAnteil: string;
  beruflicheStellung5FrauenAnzahl: number;
  beruflicheStellung5FrauenAnteil: string;
  beruflicheStellung5MaennerAnzahl: number;
  beruflicheStellung5MaennerAnteil: string;
  totalFrauenAnzahl: number;
  totalFrauenAnteil: string;
  totalMaennerAnzahl: number;
  totalMaennerAnteil: string;
}
